export default "__VITE_ASSET__XtlRmtL3__"